
import { Component, Prop, Watch,Emit,FormComponentBase} from "@/lib";
@Component({name:"hi-datepicker-other"})
export default class HiDatepicker extends FormComponentBase {
  @Prop({
    required: true,
    default: null
  })
  value: any;
  @Prop({ type: String, default: "date" }) type: string; //类型  date、daterange、year、month、datetime、datetimerange
  @Prop({ type: String, default: "dd MMM yyyy" }) format: string; //格式
  @Prop({ type: Object }) options: any;
  @Prop({ type: Boolean, default: true }) clearable: boolean;// 是否显示清除按钮
  @Prop({type:Boolean, default: false}) showWeekNumbers: boolean;//是否显示星期数
  @Prop({ type: Boolean, default: false }) transfer: boolean;

  currentDate: any = null;
  @Watch("value")
  getDate(value) {
    // 注：特殊格式（例：dd MMM yyyy），DatePicker不会将标准时间格式显示出来，所以这里进行个格式转换
    if (this.type == "date" || this.type == "year" || this.type == "month" || this.type == "datetime") {
      this.currentDate = value ? this.$util.format.date(value) : null; 
    } else {
      this.currentDate = value;
    }
  }

  get requiredRule() {
    return {
      required: true,
      message: this.L("Validate.PleaseSelect", this.L(this.labelKey)),
      trigger: "change",
      pattern: /.+/
    };
  }

  change(value) {
    if (this.type == "date" || this.type == "year" || this.type == "month" || this.type == "datetime")
      this.$emit("input", value ? this.$util.format.date(value) : null);
    else
      this.$emit(
        "input",
        value.some(item => {
          return item != "";
        })
          ? value
          : null
      );
  }
}
